import {
  usePersistentUserChoices,
  type UsePersistentUserChoicesOptions,
} from '@livekit/components-react'
import { noTry } from '@breakoutlearning/firebase-repository/util'
import { useEffect, useState } from 'react'

const AUDIO_OUTPUT_DEVICE_ID_KEY = 'lk-user-choices-audioOutputDeviceId'

const isAudioOutputSupported =
  typeof HTMLMediaElement !== 'undefined' &&
  'setSinkId' in HTMLMediaElement.prototype

export function usePersistentUserChoicesWithOutput(
  options?: UsePersistentUserChoicesOptions
) {
  const base = usePersistentUserChoices(options)

  const [audioOutputDeviceId, setAudioOutputDeviceId] = useState(() => {
    if (!isAudioOutputSupported) return ''
    if (options?.preventLoad) return ''
    try {
      return localStorage.getItem(AUDIO_OUTPUT_DEVICE_ID_KEY) ?? ''
    } catch {
      return ''
    }
  })

  useEffect(() => {
    if (options?.preventSave) return
    noTry(() =>
      localStorage.setItem(AUDIO_OUTPUT_DEVICE_ID_KEY, audioOutputDeviceId)
    )
  }, [audioOutputDeviceId, options?.preventSave])

  return {
    ...base,
    userChoices: {
      ...base.userChoices,
      audioOutputDeviceId,
    },
    saveAudioOutputDeviceId: setAudioOutputDeviceId,
    isAudioOutputSupported,
  }
}
